var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cs-button',{staticClass:"csn-delete-account",attrs:{"fill":"clear","variant":"danger","block":""},on:{"click":_vm.confirmDelete}},[_vm._v("Delete Account")])
}
var staticRenderFns = []

export { render, staticRenderFns }